import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface LineItemsTooManyHandlingUnitsQuestionBubbleProps {
  maxHandlingUnits: number;
}

export function LineItemsTooManyHandlingUnitsQuestionBubble(
  props: LineItemsTooManyHandlingUnitsQuestionBubbleProps,
) {
  return (
    <Tooltip
      variant="error"
      content={
        <Stack gap={2}>
          <T weight="bold">Too many handling units</T>
          <T size="xs" color="secondary">
            Individual shipments cannot contain more than{" "}
            {props.maxHandlingUnits} handling units in total. Smaller items
            should be combined onto pallets for proper freight shipping. Please
            contact our team if you have any questions about this.
          </T>
        </Stack>
      }
    />
  );
}
